import { render, staticRenderFns } from "./AssessmentPage.vue?vue&type=template&id=67f7b82f&scoped=true"
import script from "./AssessmentPage.vue?vue&type=script&lang=js"
export * from "./AssessmentPage.vue?vue&type=script&lang=js"
import style0 from "./AssessmentPage.vue?vue&type=style&index=0&id=67f7b82f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67f7b82f",
  null
  
)

export default component.exports